module.exports = __webpack_public_path__ + "assets/img/help.7a7988d9.png";